(function () {
    'use strict';
    angular
        .module('app')
        .directive('autoNameDialog', autoNameDialog);
    autoNameDialog.$inject = ['$window', '$rootScope', '$scope', '$timeout', 'ngClipboard', '$mdDialog'];
    function autoNameDialog($window, $rootScope, scope, $timeout, ngClipboard, $mdDialog) {
        var directive = {
            link: link,
            restrict: 'EA',
            //scope: {
            //    msgBoxShown: '=?'
            //},
            //controller: 'confirmBox',
            templateUrl: 'app/autoname/autoNameDialog.html'
        };

        return directive;
        function link(scope, element, attrs) {
        }
    }
})();